import { SET_ENTRY_COMPONENT, RESET_ENTRY_COMPONENT } from './actions'

const DEFAULT_STATE = {
  source: '',
}

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_ENTRY_COMPONENT:
      return action.payload
    case RESET_ENTRY_COMPONENT:
      return DEFAULT_STATE
  }
  return state
}
